export function searchFilterCustomers(customers, searchTerm) {
  if (!customers || customers.length === 0) return [];

  const term = searchTerm
    .replace(/[^a-zA-Z0-9\s\-_.]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

  return customers.filter((customer) => {
    const matchesSearch =
      !term ||
      customer.customerName?.toLowerCase().includes(term) ||
      customer.customerEmail?.toLowerCase().includes(term) ||
      customer.customerPhone?.toLowerCase().includes(term);

    return matchesSearch;
  });
}
